import { arrayOf, string } from 'prop-types'
import React, { Fragment } from 'react'
import HrbTranslate from '../../../components/language/HrbTranslate'
import lang from '../../../components/language/services/Lang'
import ScrollingListBox from '../../../components/library/common/ScrollingListBox'
import AssignedListItem from './AssignedListItem'

const AssignedProductsListBox = props => {

    const { assignedProducts, onAssignedProductsChanged } = props

    const handleUnassignClicked = product => {
        var newAssigned = assignedProducts.filter(o => o !== product)

        if (onAssignedProductsChanged) {
            onAssignedProductsChanged(newAssigned)
        }
    }

    return (
        <div className='column is-5'>
            <em className='p2 mb-3'>
                <HrbTranslate text='AssociateOfficesModal.AssignedProducts' />
            </em>
            <ScrollingListBox elementId='list-assigned-offices' className='product-list'>
                {(!assignedProducts) &&
                    <Fragment>
                        <AssignedListItem />
                        <AssignedListItem />
                        <AssignedListItem />
                        <AssignedListItem />
                        <AssignedListItem />
                    </Fragment>
                }
                {assignedProducts && assignedProducts.map(o =>
                    <AssignedListItem
                        key={o}
                        id={o}
                        label={lang.getCurrentValue(`AssociatesPage.ProductAssignments.${o}`)}
                        onUnassignClicked={handleUnassignClicked} />
                )}
            </ScrollingListBox>
        </div>
    )
}

AssignedProductsListBox.propTypes = {
    assignedProducts: arrayOf(string)
}

export default AssignedProductsListBox